import React from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import useHover from "../../hooks/useHover";
import { HelpIcon } from "../webplayerscrlr/HelpIconButton";

const HeaderMenuItem = props => {
    let routeMatch = useRouteMatch({path: props.route, strict: true});
    let history = useHistory();
    const [hoverRef, isHovered] = useHover();

    const onClick = () => {
        if (props.route) {
            history.push(props.route);
        }
        if (props.onClick) {
            props.onClick();
        }
    }

    const getContainerStyle = () => {
        return routeMatch
            ? {...styles.iconContainer, color: "#1BB9DA"}
            : styles.iconContainer
    }

    const renderIcon = () => {
        if (props.iconImage) {
            return <img src={props.iconImage} className="header-menu-icon-image" alt="" />;
        }
        if (props.iconClass) {
            return <i style={styles.icon} className={props.iconClass} />;
        }
        return null;
    };

    return (
        <div ref={hoverRef} onClick={onClick} style={{ ...getContainerStyle(), position: "relative" }}>
            {renderIcon()}
            {props.name}
            {props.label && (
                <HelpIcon
                    label={props.label}
                    visible={isHovered}
                    style={styles.helpIcon}
                />
            )}
        </div>
    );
}

const styles = {
    iconContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        fontSize: "14px",
        lineHeight: "20px",
        padding: "17px 12px",
        color: "#9F9F9F",
        cursor: "pointer"
    },
    icon: {
        fontSize: "20px",
        marginBottom: "5px"
    },
    helpIcon: {
        right: 0,
        top: 4,
        width: 18,
        height: 18,
        padding: 3,
    }
}

export default HeaderMenuItem;